<div>
  @if(address()) {
    <p>{{ address() }}</p>
  }
  @if(fullAddress) {
    <p>{{ fullAddress }} </p>
  }
  @if (phone()) {
    <p>{{ phone() }}</p>
  }
</div>
